import React, { useContext } from 'react';
import { useToggle } from 'react-use';
import axios from 'axios';
import styled from 'styled-components';
import { Flex, Avatar, Dropdown, Button, Text } from '../design-system';
import { IoIosAdd, IoIosArrowDown } from 'react-icons/io';
import BlockLink, { AnchorBlockLink } from './BlockLink';
import { Session } from '../contexts/sessionContext';
import { Theme } from '../theme';
import UniversalSearch from './UniversalSearch';
import ModalForm from './ModalForm';
import { checkPermissions } from '../helpers/utils';
import { ERR_MSG, PERMISSIONS } from '../globalConstants';
import { CONTACT_FIELDS } from '../containers/Contacts/constants';
import Alert from '../helpers/alert';

const Container = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 5rem;

  span {
    margin-left: 8px;
  }
`;

const UserArea = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 5rem;
  width: '100vw';
  gap: 10px;
  span {
    margin-left: 8px;
  }
`;

const StyledAvatar = styled(Avatar)`
  &:hover {
    cursor: pointer;
  }
`;

const StyledDropDownItem = styled(Dropdown.Item)`
  padding: 0;
`;

const Header = () => {
  const {
    state: {
      user: { name, permissions },
    },
    logout,
  } = useContext(Session);

  const canCreate = checkPermissions(
    permissions,
    PERMISSIONS.CREATE_CONTACT as any,
  );

  const [isModalOpen, toggleModal] = useToggle(false);

  const submitNewContact = async (values: any) => {
    try {
      await axios.post(`/contact`, values);
      toggleModal(false);
      Alert.success('New contact created');
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };
  const submitSupportTicketButton = () => {
    const win = window.open(
      'https://grantholster.zohodesk.com/portal/en/newticket?departmentId=519092000000006907',
      '_blank',
    );
    win && win.focus();
  };
  return (
    <>
      <Container>
        <div style={{ paddingLeft: 20 }}>
          {canCreate && (
            <Dropdown
              placement="bottom-start"
              width={250}
              trigger={
                <Button type="button">
                  Add <IoIosAdd size={23} />
                </Button>
              }
            >
              <Dropdown.Item onClick={toggleModal}>Contact</Dropdown.Item>
            </Dropdown>
          )}
        </div>
        <UserArea>
          <Button onClick={submitSupportTicketButton} variant="grey">
            Submit Support Ticket
          </Button>
          <UniversalSearch />
          <StyledAvatar
            backgroundColor={Theme.colors.secondaryLight}
            size={38}
            name={name}
          />
          <Text mr={2} id="displayname">
            {name}
          </Text>
          <Flex>
            <Dropdown
              placement="bottom-end"
              width={250}
              trigger={
                <Button style={{ padding: 0 }} variant="greyText">
                  <IoIosArrowDown size={23} />
                </Button>
              }
            >
              <StyledDropDownItem>
                <BlockLink to="/account">Profile</BlockLink>
              </StyledDropDownItem>
              <StyledDropDownItem>
                <AnchorBlockLink
                  href="https://desk.zoho.com/portal/grantholster/"
                  target="_blank"
                >
                  Need Help?
                </AnchorBlockLink>
              </StyledDropDownItem>
              <Dropdown.Divider />
              <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
            </Dropdown>
          </Flex>
        </UserArea>
      </Container>
      <ModalForm
        title="Add New Contact"
        isOpen={isModalOpen}
        onSubmit={submitNewContact}
        onClose={toggleModal}
        fields={CONTACT_FIELDS}
      />
    </>
  );
};

export default Header;
